import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { getConsent, setConsent } from "@/lib/consent";
import { Link } from "react-router-dom";

export const ConsentBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Defer to next tick so we don't compete with initial paint
    const id = window.setTimeout(() => {
      if (!getConsent().decided) setVisible(true);
    }, 300);
    return () => window.clearTimeout(id);
  }, []);

  if (!visible) return null;

  const decide = (analytics: boolean) => {
    setConsent(analytics);
    setVisible(false);
  };

  return (
    <div
      role="dialog"
      aria-live="polite"
      aria-label="Cookie consent"
      className="fixed bottom-4 left-4 right-4 z-[60] md:left-auto md:right-6 md:bottom-6 md:max-w-md"
    >
      <div className="rounded-2xl border border-border/60 bg-background/95 p-4 shadow-2xl backdrop-blur-md">
        <p className="text-sm text-foreground">
          We use cookies for analytics to improve Refertle. You can accept or
          decline — essential cookies always stay on.{" "}
          <Link
            to="/privacy"
            className="underline underline-offset-2 hover:text-primary"
          >
            Learn more
          </Link>
          .
        </p>
        <div className="mt-3 flex items-center justify-end gap-2">
          <Button size="sm" variant="ghost" onClick={() => decide(false)}>
            Decline
          </Button>
          <Button size="sm" onClick={() => decide(true)}>
            Accept analytics
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ConsentBanner;
